import { Hidden } from '@material-ui/core';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { InfoBarWrapper } from '../../../../../../global/components/layout/info-bar-wrapper';
import GenericStepper from '../../../../../../global/components/navigation/generic-stepper';
import { genericStepperStyles } from '../../../../../../global/constants/theme/styles/components/generic-stepper';
import { Institution } from '../../../../../../global/models/institution-model';
import { getAdoptionStepFromLocation } from '../factory/plan-adoption-wizard-factory';
import { LayDcPlanFormModel, PlanSubmitRequest } from '../models/plan-adoption-form-models';
import { QccoPlanAdoptionWizard } from '../wizards/qcco-plan-adoption-wizard';

interface Props {
    institution: Institution;
    wizard: QccoPlanAdoptionWizard;
}

function PlanAdoptionStepper(props: Props) {

    const location = useLocation();

    const { institution, wizard } = props;
    const classes = genericStepperStyles();
    const content = wizard?.getFormContentModel();
    const sectionTitle: string = content?.adoptingPlanStepperLabel;
    const clientNumberLabel: string = content?.clientIdLabel;
    const basePath = wizard?.wizardOptions.featureRootPath;

    const currentStep = getAdoptionStepFromLocation(location);

    const initialValues: LayDcPlanFormModel = wizard?.getFormInitialValue();

    const planSubmitRequest: PlanSubmitRequest = {
        clientId: institution?.org_client_nbr,
        values: initialValues,
    };

    function onStepperClick(step: any, subPath: string): void {
        const featureUrl = wizard?.wizardOptions?.featureRootPath;
        const nextPath = `${featureUrl}${subPath}`;
        wizard?.navigateToPath(nextPath, planSubmitRequest);
    }

    return (
        <>
            <div className={classes.genericStepperContainer}>
                <div className='generic-ministepper'>
                    <GenericStepper
                        basePath={basePath}
                        allSteps={wizard?.getStepperSteps()}
                        useCurrentStep={() => currentStep}
                        setCurrentStep={null}
                        progressItems={wizard?.getStepperProgressItems()}
                        onCustomStepperClick={onStepperClick}
                    />
                    <Hidden mdDown>
                    <div className='generic-ministepper-infobar'>
                        <h3>{sectionTitle}</h3>
                        <p>{institution?.organization_name}</p>
                        <p>{clientNumberLabel || 'Client ID'}: {institution?.org_client_nbr}</p>
                        </div>
                    </Hidden>
                </div>
            </div>
            <Hidden lgUp>
                <InfoBarWrapper>
                    <div>
                        <h3>{sectionTitle}</h3>
                        <p>{institution?.organization_name}</p>
                        <p>{clientNumberLabel || 'Client ID'}: {institution?.org_client_nbr}</p>
                    </div>
                </InfoBarWrapper>
            </Hidden>
        </>
    );

}

export default PlanAdoptionStepper;